<div class="page-overlay-wrapper" *ngIf="showLoader">
    <div class="bee-spinner"></div>
</div>

<!-- <mat-spinner *ngIf="showLoader"></mat-spinner> -->